import { DELAY_TYPE } from '@lighthouse/core'

export const EventDelayLabel = {
    [DELAY_TYPE.NONE]: '无',
    [DELAY_TYPE.DEBOUNCE]: '防抖',
    [DELAY_TYPE.THROTTLE]: '节流'
}

export const EventDelayOptions = [
    {
        label: '无',
        value: DELAY_TYPE.NONE
    },
    {
        label: '防抖',
        value: DELAY_TYPE.DEBOUNCE
    },
    {
        label: '节流',
        value: DELAY_TYPE.THROTTLE
    }
]
